import type { CaseStatus } from '@casetrace/shared';

const STATUS_STYLES: Record<CaseStatus, string> = {
  active: 'bg-success/10 text-success',
  archived: 'bg-white/[0.07] text-[#8b8d9a]',
  closed: 'bg-white/[0.07] text-[#5e6070]',
};

const STATUS_LABELS: Record<CaseStatus, string> = {
  active: 'Aktiv',
  archived: 'Arkivert',
  closed: 'Lukket',
};

interface StatusBadgeProps {
  status: CaseStatus;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${STATUS_STYLES[status]}`}
    >
      {STATUS_LABELS[status]}
    </span>
  );
}
